var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"overflow":"hidden","height":"100%","width":"100%"},attrs:{"src":"https://facedub.developerhub.io/facedub/frequently-asked-questions","frameborder":"0","height":"100%","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }